<template>
    <div class="mfooterBox">
         <div class="companyInfo">
              <div class="item tel clearfix">
                   <div class="dd">
                        <img src="../../assets/images/mtel.png">
                   </div>
                   <div class="dt">
                         <div class="name">{{$t('footer.tel')}}</div>
                        <div class="info"> {{ contact.tel }}</div>
                   </div>
             </div>
             <div class="item mail clearfix">
                 <div class="dd">
                       <img src="../../assets/images/mail.png">
                   </div>
                   <div class="dt">
                        <div class="name">{{$t('footer.mail')}}</div>
                        <div class="info">{{ contact.email }}</div>
                   </div>
                  
             </div>
             <div class="item address clearfix">
                 <div class="dd">
                        <img src="../../assets/images/local.png">
                   </div>
                   <div class="dt">
                        <div class="name">{{$t('footer.address')}}</div>
                        <div v-if="currentLang=='zh'" class="info">
                                {{ CompanyInfo.address }}
                        </div>
                        <div v-else class="info">
                                {{ CompanyInfo.enAddress }}
                        </div>
                   </div>
             </div>
             <div class="codeinfo">
                <img src="../../assets/images/weixin@2x.png">
            </div>    
         </div>
         <div class="copy" v-if="currentLang == 'zh'" v-html="CompanyInfo.copyright"></div>
      <div class="copy" v-else  v-html="CompanyInfo.enCopyright"></div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  data() {
    return {
        CompanyInfo: {},
        contact:{},
        currentLang: this.$i18n.locale
    };
  },
  components: {
    
  },
  mounted() {
    
  },
  created: function () {
     this.GetInfo();
  },
  methods: {
    ...mapActions([
      'setCompanyInfo'
    ]),
    GetInfo() {
      var url = "/pageapi/common/GetCompanyInfo";
      this.$http.post(url, {}).then(
        function (res) {
          if (res.data.status == 1) {
            this.CompanyInfo = res.data.ds;
            this.contact=JSON.parse(res.data.ds.contactList)[0];
            this.setCompanyInfo(res.data.ds);

          }
        }.bind(this)
      )
        .catch(function (error) { });
    },
  }
};
</script>